<div class="container_principal poppins-font">
    <div class="container_info fade-in">
        <div class="content_info_txt">
            <img class="confirm" src="assets/img/notificacion/confirm_icon.png">
            <div class="txt_info">
                <h4>Hemos recibido tu solicitud</h4>
                <!-- <h5>asasasas</h5> -->
                <p>Será un placer atenderte</p>

                <h6>{{ msg }}</h6>
            </div>
            

             <div class="btn-group">
          <!-- <button class="btn_prev" type="button" (click)="prevStep()">Regresar</button> -->
          <button type="button" (click)="volver()">Aceptar</button>
        </div>
        </div>
    </div>

    <img  src="assets/img/redActiva/team_webActiva.webp" class="teamRed">
</div>
